export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.foopy.com.au";